// consult https://router.vuejs.org/en/index.html
export default [
	{
		path: '/',
		component: require('views/commons/home')
	},
	{
		path: '/cadastro',
		component: require('views/municipe/cadastro')
	},
	{
		path: '/agendamentos',
		component: require('views/municipe/agendamentos')
	},
	{
		path: '/agendas',
		component: require('views/agendas/listar')
	},
	{
		path: '/agendas/:data',
		component: require('views/agendas/agenda')
	},
	{
		path: '/agendas/:data/cadastro',
		component: require('views/agendas/cadastro')
	},
	{
		path: '/login',
		component: {
			render(h) {
				return h('div', { 'class': ['row'] }, [
					h('div', { 'class': ['col-md-6', 'col-md-offset-3'] }, [
						h(require('views/permisys/login'))
					])
				]);
			}
		}
	},
	{
		path: '/recuperarsenha',
		component: require('views/permisys/recuperarSenha')
	},
	{
		path: '/confirmacaopresenca',
		component: require('views/agendas/confirmacaoPresenca')
	},
	{
		path: '*',
		component: require('views/commons/page404')
	}
];


// WEBPACK FOOTER //
// ./application/routes.js